import { api } from '@/services'

export const list = (params) => {
  return api.get(`admin/transfer/list?${params}`)
}

export const fetchDetails = (id) => {
  return api.get(`admin/transfer/details/${id}`)
}

export const retryTransfer = (transfers) => {
  return api.post('admin/transfer/execute', transfers)
}

export const createReport = (params) => {
  return api.get(`admin/transfer/createReport?${params}`, { responseType: 'arraybuffer' })
}